/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
const o = "dropdowns.nodata", a = "dropdowns.clear", r = "dropdowns.comboArrowBtnAriaLabelExpand", n = "dropdowns.comboArrowBtnAriaLabelCollapse", e = "dropdowns.dropDownListArrowBtnAriaLabel", d = "dropdowns.apply", p = "dropdowns.cancel", s = {
  [a]: "clear",
  [o]: "NO DATA FOUND.",
  [r]: "expand combobox",
  [n]: "collapse combobox",
  [e]: "select",
  [d]: "Apply",
  [p]: "Cancel"
};
export {
  d as adaptiveModeFooterApply,
  p as adaptiveModeFooterCancel,
  a as clear,
  n as comboArrowBtnAriaLabelCollapse,
  r as comboArrowBtnAriaLabelExpand,
  e as dropDownListArrowBtnAriaLabel,
  s as messages,
  o as nodata
};
